
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnChanges,
  ViewChild
} from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { FormatDateTimePipe, RolloutPlanListItems } from '@ottobock/remote-update/domain';

import { RolloutPlanTableDataSource } from './rollout-plan-table-datasource';

@Component({
  selector: 'remote-update-feature-remote-update-dashboard-rollout-plan-table',
  templateUrl: './rollout-plan-table.component.html',
  styleUrl: './rollout-plan-table.component.css',
  imports: [MatTableModule, MatPaginatorModule, MatSortModule, FormatDateTimePipe]
})
export class RolloutPlanTableComponent implements AfterViewInit, OnChanges {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatTable) table!: MatTable<RolloutPlanListItems>;

  router = inject(Router);

  @Input() rolloutPlanData: RolloutPlanListItems[] | null = [];
  private cd = inject(ChangeDetectorRef);

  dataSource = new RolloutPlanTableDataSource([]);

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['state', 'packageVersion', 'updatedAt'];

ngAfterViewInit(): void {
  this.dataSource.sort = this.sort;
  this.dataSource.paginator = this.paginator;
  this.table.dataSource = this.dataSource;
}
  ngOnChanges(): void {
    this.refreshTable();
  }

  private refreshTable() {
    if (!this.rolloutPlanData) return;

    this.dataSource.setRolloutPlanData(this.rolloutPlanData);

    if (this.sort) this.dataSource.sort = this.sort;
    if (this.paginator) this.dataSource.paginator = this.paginator;

    if (this.table) this.table.dataSource = this.dataSource;
    if (this.paginator) this.paginator._changePageSize(this.paginator.pageSize);
  }

  goToDetails(rollout: RolloutPlanListItems): void {
    this.router.navigate(['rollout-plan/details', rollout.rolloutPlanId]);
  }
}
